/**
 * Exceldownload working with NSWOW2 Tables
 */

class XTableNamer {
  constructor() {
    const elements = Array.prototype.slice.call(document.querySelectorAll('.iz-content .lc-table-wrap, .iz-content .lc-title-h1, .iz-content .lc-title-h2, .iz-content .lc-title-h5, .iz-content .accordion__title'));

    let h1;
    let h2;
    let c;
    const pageTitle = document.querySelector('[class*="lc-title-"]');

    elements.forEach(element => {

      const className = Array.from(element.classList).find(cls => ['lc-table-wrap', 'lc-title-h1', 'lc-title-h2', 'lc-title-h5', 'accordion__title'].includes(cls));

      switch (className) {
        case "lc-title-h1":
          h1 = element.innerText || ''; // Ensure h1 is a string
          c = 0;
          break;
        case "lc-title-h2":
          if (element.innerText && element.innerText.trim()) { // Check if innerText exists
            h2 = element.innerText;
            //console.log("h1", h1);
            c = 0;
          }
          break;
        case "lc-title-h5":
          if (element.innerText && element.innerText.trim()) {
            h1 = element.innerText;
            c = 0;
          }
          break;
        case "accordion__title":
          const spanL = element.querySelector('span:last-child');
          if (spanL && spanL.innerText && spanL.innerText.trim()) { // Ensure spanL and its innerText exist
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "lc-table-wrap":
          let title = '';
          let fileTitle = '';
          if (pageTitle && pageTitle.innerText) { // Ensure pageTitle exists
            title += pageTitle.innerText + ' – ';
          }
          if (h1) {
            title += h1.trim();
          }
          if (h2) {
            title += ' - ' + h2.trim();
            fileTitle += h2.trim().replace(/\s/g, '_');
          } else if (h1) {
            fileTitle += h1.trim().replace(/\s/g, '_');
          }
          if (c > 0) {
            title += ' ' + (c + 1);
            fileTitle += '_' + (c + 1);
          }
          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          c++;
          break;
      }
    });
  }
}

export default XTableNamer;
